import React from 'react';
import { Navigate } from 'react-router-dom';

import { useMainScreenExperiment } from 'hooks/common/useMainScreenExperiment';

import { PageLoader } from 'components/PageLoader';

import { isTabletDevice } from 'theme/verifiers';

import { AppDownloadMobileModule } from './AppDownloadMobileModule';
import { DownloadAppModule } from './DownloadAppModule';

export const DownloadPageGuard = () => {
    const { redirectPath, isReady } = useMainScreenExperiment();

    if (!isReady) {
        return <PageLoader />;
    }

    return <Navigate to={redirectPath} replace />;
};

export const DownloadAppPage = () => {
    return isTabletDevice ? <DownloadAppModule /> : <AppDownloadMobileModule />;
};
